import React from "react";
import "./MofaContent.css";
const MofaContent = () => {
  return (
    <div className="mofaHeadContent">
      <h3>
        MOFA <span>Attestation</span> Procedure :
      </h3>
      <p>
        All original documents requiring attestation or Apostille should be
        first authenticated by the designated agencies in the State from where
        the document has been issued. In case of personal documents, Home
        Department /General Administration Department are the designated
        authorities. In case of educational documents, the documents should
        first be authenticated by the Education Department of the concerned
        State Government/Union Territory. The details of the Regional
        Authentication Centre (RACs) in the States/UTs from where the documents
        should first be authenticated are given below. The Ministry of External
        Affairs attests the documents on the basis of the signature of the
        designated signing authorities of the State Government/Union
        Territory/Chambers of Commerce; hence it does not take responsibility of
        the contents of the documents.
      </p>
    </div>
  );
};

export default MofaContent;
